import { massToSize, sizeToMass } from '../formulas';
import type { Action, ActionContext } from './action';
import { consumePulses } from './action';

/**
 * SHRINK — each consumed click dumps a fraction of mass (down to the world min
 * size) and refreshes a short speed boost. Combined with the fact that smaller
 * == faster, this makes shrinking a real escape move. Capped by its own token
 * bucket.
 */
export const shrinkAction: Action = {
  id: 'shrink',
  apply({ entity, cfg, dt }: ActionContext): void {
    const s = cfg.actions.shrink;
    const used = consumePulses(entity, 'shrink', dt, s.maxPerSec, s.burst);
    if (used <= 0) return;
    const mass = sizeToMass(entity.size) * Math.max(0, 1 - s.massFractionPerPulse * used);
    entity.size = Math.max(cfg.world.minSize, massToSize(mass));
    // Refresh (don't stack) the escape boost.
    entity.boostTimer = s.boostDurationSec;
  },
};
